import { LinearProgress, Typography } from "@material-ui/core";
import { push } from "connected-react-router";
import React from "react";
import { connect } from "react-redux";
import AccountData from "../AccountData";
import { AppState } from "../redux";
import Upload from "./Upload";

interface Props {
  result: AppState["report"]["summary"];
  loading: boolean;
}

class Main extends React.Component<Props> {
  public render() {
    if (this.props.loading) {
      return <LinearProgress />;
    }
    return (
      <React.Fragment>
        <Upload />
        <p>&nbsp;</p>
        <Typography variant="h4" gutterBottom>
          Auswertung
        </Typography>
        <AccountData result={this.props.result} />
      </React.Fragment>
    );
  }
}

export default connect(
  (state: AppState) => ({
    loading: state.loading.status,
    result: state.report.summary
  }),
  dispatch => ({
    link: (path: string) => dispatch(push(path))
  })
)(Main);



// WEBPACK FOOTER //
// ./src/Main/index.tsx